import {
  BaseReducerState,
  SlipPDFAPIResponse,
} from '../../../services'
import { ActionTypes } from '../actions'

export type SlipPDFState = BaseReducerState & {
  data: string
}

const slipPDFInitialState: SlipPDFState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

const handlePdfRequest = (state: SlipPDFState): SlipPDFState => ({
  ...state,
  loading: true,
  success: false,
  message: null,
  data: null,
  error: null,
})

const handlePdfSuccess = (
  state: SlipPDFState,
  action: { type: string; res: any }
): SlipPDFState => {
  const { success, data, message } = <SlipPDFAPIResponse>action.res
  return {
    ...state,
    loading: false,
    success,
    message,
    ...(success && data && { data }),
  }
}

const handlePdfFailure = (
  state: SlipPDFState,
  action: { type: string; res: any }
): SlipPDFState => {
  const res = <SlipPDFAPIResponse>action.res
  const { message } = res || {}
  res.error ??= message
  const { error } = res
  return {
    ...state,
    loading: false,
    success: false,
    message,
    error,
  }
}

const handlePdfReset = (state: SlipPDFState): SlipPDFState => ({
  ...state,
  loading: false,
  success: false,
  message: null,
  data: null,
  error: null,
})

export const slipPDF = (
  state: SlipPDFState = slipPDFInitialState,
  action: { type: string; res: any }
): SlipPDFState => {
  switch (action.type) {
    case `${ActionTypes.GET_SLIP_PDF}_REQUEST`:
    case `${ActionTypes.GET_SITE_CHALLANS_PDF}_REQUEST`:
    case `${ActionTypes.GET_SITE_CHALLANS_EXCEL}_REQUEST`:
      return handlePdfRequest(state)

    case `${ActionTypes.GET_SLIP_PDF}_SUCCESS`:
    case `${ActionTypes.GET_SITE_CHALLANS_PDF}_SUCCESS`:
    case `${ActionTypes.GET_SITE_CHALLANS_EXCEL}_SUCCESS`:
      return handlePdfSuccess(state, action)

    case `${ActionTypes.GET_SLIP_PDF}_FAILURE`:
    case `${ActionTypes.GET_SITE_CHALLANS_PDF}_FAILURE`:
    case `${ActionTypes.GET_SITE_CHALLANS_EXCEL}_FAILURE`:
      return handlePdfFailure(state, action)

    case `${ActionTypes.GET_SLIP_PDF}_RESET`:
    case `${ActionTypes.GET_SITE_CHALLANS_PDF}_RESET`:
    case `${ActionTypes.GET_SITE_CHALLANS_EXCEL}_RESET`:
      return handlePdfReset(state)
  }
  return state
}
